/* RoyalChild 2026-11 pages: simple motion + plain controls (Enzo 2026-11-02:
   "we dont have to do anything fancy for motions"). */
(function () {
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* one soft fade-up per section, once */
  var fades = $$('.rc26 [data-k-fade]');
  if ('IntersectionObserver' in window && fades.length) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    fades.forEach(function (el) { io.observe(el); });
  } else { fades.forEach(function (el) { el.classList.add('is-in'); }); }

  /* home chips: links to real collections; mark the hovered/focused one */
  $$('[data-k-chips]').forEach(function (row) {
    var chips = $$('.k-chip', row);
    chips.forEach(function (c) {
      c.addEventListener('click', function () { chips.forEach(function (x) { x.classList.toggle('is-on', x === c); }); });
    });
  });

  /* founder video carousel: swipe / arrows / dots, centre card active */
  $$('[data-k-car]').forEach(function (car) {
    var track = car.querySelector('.k-car__track');
    var cards = $$('.k-vid', track);
    var dots = $$('.k-car__dot', car);
    var names = $$('[data-k-name]', car);
    if (!cards.length) return;
    var idx = 0;
    function mark(i) {
      idx = i;
      cards.forEach(function (c, j) {
        c.classList.toggle('is-active', j === i);
        /* no tilt: motion kept simple (Enzo 2026-11-02) */
      });
      dots.forEach(function (d, j) { d.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      names.forEach(function (n, j) { n.hidden = j !== i; });
    }
    function go(i) {
      i = Math.max(0, Math.min(cards.length - 1, i));
      var c = cards[i];
      track.scrollTo({ left: c.offsetLeft - (track.clientWidth - c.clientWidth) / 2, behavior: 'smooth' });
      mark(i);
    }
    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var mid = track.scrollLeft + track.clientWidth / 2, best = 0, bd = 1e9;
        cards.forEach(function (c, j) { var d = Math.abs(c.offsetLeft + c.clientWidth / 2 - mid); if (d < bd) { bd = d; best = j; } });
        mark(best);
      }, 80);
    }, { passive: true });
    dots.forEach(function (d, j) { d.addEventListener('click', function () { go(j); }); });
    var p = car.querySelector('.k-car__btn--prev'), n = car.querySelector('.k-car__btn--next');
    if (p) p.addEventListener('click', function () { go(idx - 1); });
    if (n) n.addEventListener('click', function () { go(idx + 1); });
    cards.forEach(function (c, j) {
      c.addEventListener('click', function (e) { if (j !== idx) { e.preventDefault(); go(j); } });
    });
    /* play: swap the poster for the real video */
    $$('[data-k-play]', car).forEach(function (b) {
      b.addEventListener('click', function (e) {
        var card = b.closest('.k-vid'), tpl = card.querySelector('template');
        if (!tpl) return;
        e.preventDefault();
        card.innerHTML = tpl.innerHTML;
        var v = card.querySelector('video'); if (v) { v.play && v.play(); }
      });
    });
    window.addEventListener('resize', function () {
      var c = cards[idx]; track.scrollLeft = c.offsetLeft - (track.clientWidth - c.clientWidth) / 2;
    });
    var start = cards.length > 1 ? 1 : 0;
    mark(start);
    requestAnimationFrame(function () {
      var c = cards[start];
      track.scrollLeft = c.offsetLeft - (track.clientWidth - c.clientWidth) / 2;
    });
  });

  /* prayer accordion + filter + copy + save */
  $$('[data-k-prayers]').forEach(function (root) {
    var rows = $$('.k-prow', root);
    rows.forEach(function (r) {
      var h = r.querySelector('.k-prow__head');
      h.addEventListener('click', function () {
        var open = !r.classList.contains('is-open');
        r.classList.toggle('is-open', open);
        h.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
    var chips = $$('.k-fchip', root), empty = root.querySelector('.k-pray__empty');
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        var f = c.getAttribute('data-filter'), shown = 0;
        chips.forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
        rows.forEach(function (r) {
          var ok = f === 'all' || r.getAttribute('data-cat') === f;
          r.hidden = !ok; if (ok) shown++;
        });
        if (empty) empty.hidden = shown > 0;
      });
    });
    var KEY = 'rc:prayers', saved = [];
    try { saved = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) {}
    $$('[data-k-save]', root).forEach(function (b) {
      var id = b.getAttribute('data-k-save');
      b.setAttribute('aria-pressed', saved.indexOf(id) !== -1 ? 'true' : 'false');
      b.addEventListener('click', function () {
        var i = saved.indexOf(id);
        if (i === -1) saved.push(id); else saved.splice(i, 1);
        b.setAttribute('aria-pressed', i === -1 ? 'true' : 'false');
        b.querySelector('span').textContent = i === -1 ? 'Saved' : 'Save';
        try { localStorage.setItem(KEY, JSON.stringify(saved)); } catch (e) {}
      });
      if (saved.indexOf(id) !== -1) b.querySelector('span').textContent = 'Saved';
    });
    $$('[data-k-copy]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var txt = b.closest('.k-prow').querySelector('.k-prow__text');
        if (!txt) return;
        var s = txt.innerText.trim(), lab = b.querySelector('span');
        var done = function () { lab.textContent = 'Copied'; setTimeout(function () { lab.textContent = 'Copy prayer'; }, 1800); };
        if (navigator.clipboard) navigator.clipboard.writeText(s).then(done, done); else done();
      });
    });
  });
})();
